import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    makeStyles,
    TextField,
} from "@material-ui/core"
import { ArrowForwardIos } from "@material-ui/icons"
import { useContext, useRef, useState } from "react"
import SiteContext from "../../../contexts/SiteContext"
import { CodigoCartaoMask, NumeroCartaoMask, VencimentoCartaoMask } from "../../../masks/cartao"
import CpfMask from "../../../masks/cpf"
import { CadastrarCartaoCliente, RegistrarLogErro } from "../../../services/functions"
import { criptografarCartaoPagSeguro } from "../../../services/pagseguro"

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexWrap: "wrap",
        gap: "1rem",
        "& input": {
            backgroundColor: "white",
        },
        "& > *": {
            flex: "1 1 100%",
        },
        "& > .codigo-verificacao-cartao, .data-vencimento-cartao, .cpf-titular-cartao": {
            flex: "1 1 10rem",
        },
    },
    credit_or_debit_container: {
        gridColumn: "1 / 3",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
    },
})

const DialogCadastroCartao = props => {
    const classes = useStyles()
    const { carrinho, usuarioLogado, aplicativoDados } = useContext(SiteContext)

    const handleClose = () => props.setAbrirDialogCadastroCartao(false)

    const [cardType, setCardType] = useState("PAGSEGURO_CREDITO")
    const handleChangeCardType = e => setCardType(e.target.value)

    const numeroCartaoRef = useRef()
    const nomeCartaoRef = useRef()
    const codigoCartaoRef = useRef()
    const vencimentoCartaoRef = useRef()
    const cpfRef = useRef()
    const emailRef = useRef()

    const handleCadastrarCartao = async e => {
        try {
            e.preventDefault()
            props.setLoading(true)

            const numeroCartao = numeroCartaoRef.current.value.replaceAll(" ", "").trim()
            const nomeCartao = nomeCartaoRef.current.value
            const codigoCartao = codigoCartaoRef.current.value.trim()
            const vencimentoCartao = vencimentoCartaoRef.current.value.trim()
            const cpf = cpfRef.current.value.replaceAll(".", "").replace("-", "")
            const email = emailRef.current.value.trim()

            const dataSeparada = vencimentoCartao.split("/")
            const numeroMes = Number(dataSeparada[0])

            // TODO: Criar trava para cliente não logado

            if (!cardType) {
                props.alertStart("Escolha o tipo de cartão", "warning")
                props.setLoading(false)
                return
            }

            if (numeroCartao.length < 13 || numeroCartao.length > 19) {
                props.alertStart("Número de cartão inválido", "warning")
                props.setLoading(false)
                return
            }

            if (!nomeCartao.trim().includes(" ")) {
                props.alertStart("Digite seu nome completo", "warning")
                props.setLoading(false)
                return
            }

            if (codigoCartao.length < 3) {
                props.alertStart("Código de segurança inválido", "warning")
                props.setLoading(false)
                return
            }

            if (vencimentoCartao.length !== 5 || numeroMes < 1 || numeroMes > 12) {
                props.alertStart("Data de vencimento inválida", "warning")
                props.setLoading(false)
                return
            }

            if (cpf.length !== 11) {
                props.alertStart("CPF inválido" + cpf + " - " + cpf.length, "warning")
                props.setLoading(false)
                return
            }

            if (!(email.includes("@") && email.includes("."))) {
                props.alertStart("E-mail inválido", "warning")
                props.setLoading(false)
                return
            }

            const card = {
                numeroCartao: numeroCartao,
                nomeCartao: nomeCartao,
                mesValidade: dataSeparada[0],
                anoValidade: "20" + dataSeparada[1],
                codigoCartao: codigoCartao,
            }

            const cartaoCriptografado = criptografarCartaoPagSeguro({
                numeroCartao: numeroCartao,
                nomeCartao: nomeCartao,
                mesValidade: dataSeparada[0],
                anoValidade: "20" + dataSeparada[1],
                codigoCartao: codigoCartao,
            })

            card.cartaoCriptografado = cartaoCriptografado.encryptedCard
            card.tipoCartao = cardType

            if (card.hasErrors) {
                // TODO: Tratar erro (vem em inglês)
                const allErrorsString = card.errors.reduce(
                    (prev, currError) => prev.concat(`${currError.code}: ${currError.message}\n`),
                    ""
                )

                props.alertStart(allErrorsString, "error")
                console.error(allErrorsString)
                return
            }

            const objetoCartao = {
                cliente: usuarioLogado
                    ? {
                          id: usuarioLogado.cliente.id,
                          versao: usuarioLogado.cliente.versao,
                      }
                    : null,
                codigoPagamento: cardType,
                // descricao: "descricao-teste",
                nomeImpressoCartao: card.nomeCartao,
                numeroCartao: card.numeroCartao.replace(
                    /(\d\d\d\d)(\d\d\d\d)(\d\d\d\d)(\d\d\d\d(\d\d\d)?)/,
                    "XXXX-XXXX-XXXX-$4"
                ),
                cpf: cpf,
                email: email,
                // bandeira: "VISA", //TODO: Pegar a partir de número
                // bin: "bin-teste",
                // codigoBanco: "codigo-banco-teste",
                mesValidade: card.mesValidade,
                anoValidade: card.anoValidade,
                tokenCartao: card.cartaoCriptografado,
                // tokenIugu: card.cartaoCriptografado,
                // tokenLive: card.cartaoCriptografado,
                appName: aplicativoDados.appNome,
                ativo: true,
            }

            const response = await CadastrarCartaoCliente(objetoCartao, aplicativoDados)

            if (response.retornoErro) {
                props.alertStart(response.mensagem, "error")
                props.setLoading(false)
                return
            }

            carrinho.pedido.cartaoCreditoCliente = response
            // carrinho.pedido.tokenCartaoCredito = response.tokenCartao

            props.setAbrirDialogCadastroCartao(false)
            props.setLoading(false)

            props.setAbrirDialogCadastroCartao(false)
        } catch (error) {
            console.error(error)
            props.alertStart(error.message, "error")
            props.setLoading(false)
            RegistrarLogErro(error, "handleCadastrarCartao")
        }
    }

    return (
        <Dialog open={props.abrirDialogCadastroCartao} onClose={handleClose}>
            <DialogTitle>
                <IconButton className="setaVoltarModal" onClick={handleClose}>
                    <ArrowForwardIos />
                </IconButton>
                Cadastro de Cartão PagSeguro
            </DialogTitle>
            <form onSubmit={handleCadastrarCartao}>
                <DialogContent>
                    <div className={classes.container}>
                        {/* Comentado por incompatibilidade de Débito no momento */}
                        {/* <RadioGroup
                            row
                            className={classes.credit_or_debit_container}
                            value={cardType}
                            onChange={handleChangeCardType}
                        >
                            <FormControlLabel
                                control={<Radio />}
                                label="Crédito"
                                value="PAGSEGURO_CREDITO"
                            />
                            <FormControlLabel
                                control={<Radio />}
                                label="Débito"
                                value="PAGSEGURO_DEBITO"
                            />
                        </RadioGroup> */}
                        <TextField
                            label="Número do Cartão"
                            name="numero-cartao"
                            className="numero-cartao"
                            variant="outlined"
                            InputProps={{ inputComponent: NumeroCartaoMask }}
                            // Checar se máscara está correta. Quantos dígitos são?
                            inputRef={numeroCartaoRef}
                        />
                        <TextField
                            label="Nome do Titular do Cartão"
                            name="nome-titular-cartao"
                            className="nome-titular-cartao"
                            variant="outlined"
                            inputRef={nomeCartaoRef}
                        />
                        <TextField
                            label="CVV"
                            name="codigo-verificacao-cartao"
                            className="codigo-verificacao-cartao"
                            variant="outlined"
                            InputProps={{ inputComponent: CodigoCartaoMask }}
                            inputRef={codigoCartaoRef}
                        />
                        <TextField
                            label="Data de Vencimento"
                            name="data-vencimento-cartao"
                            className="data-vencimento-cartao"
                            variant="outlined"
                            InputProps={{ inputComponent: VencimentoCartaoMask }}
                            inputRef={vencimentoCartaoRef}
                        />
                        <TextField
                            label="CPF do Titular"
                            name="cpf-titular-cartao"
                            className="cpf-titular-cartao"
                            variant="outlined"
                            InputProps={{ inputComponent: CpfMask }}
                            inputRef={cpfRef}
                        />
                        <TextField
                            label="E-mail do Titular"
                            name="email-titular-cartao"
                            className="email-titular-cartao"
                            variant="outlined"
                            inputRef={emailRef}
                        />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button type="submit">Cadastrar</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default DialogCadastroCartao
